const ENDPOINTS = {
  ONLINE_SERVICES: {
    CONFIG: {
      GET_ALL: "config",
    },
    RESERVATION_TYPES: {
      GET_ALL: "reservation-types",
    },
    AVAILABLE_DATES: 'available-dates',
    OPENING_TIMES: {
      GET_ALL: "opening-times",
    },
    MENU_TYPES: {
      GET_ALL: "menu-types",
    },
    ORDER_PDF: {
      GET_ALL: "orderPdf",
    },
  },
};

export default ENDPOINTS;
